'use strict';

var _hammerjs = require('hammerjs');

var _hammerjs2 = _interopRequireDefault(_hammerjs);

require('../../../@Neptune/scripts/_n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener("DOMContentLoaded", function (event) {

  document.querySelectorAll('#deck').forEach(function (el) {
    var mc = new _hammerjs2.default(el);
    mc.on('swipe', function (ev) {
      if (ev.deltaX < -50) {
        el.querySelector('.card:not(.out)').classList.add('out');
      }
      if (ev.deltaX > 50) {
        Array.from(el.querySelectorAll('.card.out')).reverse()[0].classList.remove('out');
      }
    });
  });
});